<template>
  <div class="top-bar--left host-info" @click="toggleHost">
    <i class="icon icon--play"></i>
    <h3>{{hostName}}</h3>
    <b-tooltip :target="'host-platform-' + host.host_id">
      {{platformName}}<br v-if="localIp" /><span v-if="localIp">{{$t('printers.host.localIp')}}: <a :href="'http://'+localIp" target="_blank">{{localIp}}</a></span>
    </b-tooltip>
    <icon-mac v-b-tooltip.hover :title="platformName" v-if="host.platform==='mac'"></icon-mac>
    <icon-linux v-b-tooltip.hover :title="platformName" v-else-if="host.platform==='linux'"></icon-linux>
    <icon-windows v-b-tooltip.hover :title="platformName" v-else-if="host.platform==='win'"></icon-windows>
    <icon-rpi v-b-tooltip.hover :title="platformName" v-else-if="host.platform==='rpi'"></icon-rpi>
    <icon-not-applicable v-b-tooltip.hover :title="platformName" v-else></icon-not-applicable>
    <span v-b-tooltip.hover :title="$t('printers.host.macAddress')">{{host.host_num}}</span>
    <i v-if="isOutDateCliVersion"
       class="icon icon--error icon--error--in-tog icon--error--yellow"
       v-b-tooltip.hover
       :title="outDateCliVersionText">
    </i>
  </div>
</template>

<script>

  import IconMac from "../../icons/IconMac";
  import IconLinux from "../../icons/IconLinux";
  import IconWindows from "../../icons/IconWindows";
  import IconRpi from "../../icons/IconRpi";
  import IconNotApplicable from "../../icons/IconNotApplicable";

  export default {
    name: 'host-info',
    props: ['hostIndex', 'host'],
    components: {
      IconMac,
      IconLinux,
      IconWindows,
      IconRpi,
      IconNotApplicable
    },
    computed: {
      hostName() {
        return this.host.host_name ? this.host.host_name : this.host.host_name_calculated;
      },
      platformName() {
        switch (this.host.platform) {
          case 'mac': return 'Mac OS';
          case 'linux': return 'Linux';
          case 'win': return 'Windows';
          case 'rpi': return 'Raspberry Pi';
          default: return 'Unknown OS';
        }
      },
      localIp() {
        if (this.host.local_ip && this.host.local_ip != 0 && this.host.host_num.slice(0,2)!='0x') {
          return this.host.local_ip
        }

        return null;
      },
      isOutDateCliVersion() {
        return this.host.host_num.trim().indexOf('RND_') !== 0 && this.host.last_cli_ver;
      },
      outDateCliVersionText() {
        if (!this.isOutDateCliVersion) {
          return '';
        }
        if (this.host.cli_ver) {
          return this.$t('printers.host.versionWarningDetailed', {lastVer: this.host.last_cli_ver, userVer: this.host.cli_ver});
        }

        return this.$t('printers.host.versionWarning', {lastVer: this.host.last_cli_ver});
      }
    },
    methods: {
      toggleHost() {
        this.$emit('toggle');
      }
    }
  }
</script>

<style lang="scss" scoped>
  .host-info {
    color: white;

    h3, span {
      margin: 0;
      font-size: 18px;
    }

    svg {
      margin: 0 12px;
    }
  }
</style>